import Component, { loadComponent } from '../../../assets/scripts/modules/component.js'
import extractMicrioUrlParts from '../../../assets/scripts/utilities/extract-micrio-url-parts.js'

const dataUrlTEMP = id => `https://b.micr.io/${id}/data.en.json`

class ThemeBarComponent extends Component {
  init() {
    this.templateTitle = this.element.querySelector('.theme-bar__title-template')
    this.templateButton = this.element.querySelector('.theme-bar__button-template')

    window.addEventListener('micrio-data', event => this.initAfterData(event?.detail?.themes || {}))
  }

  initAfterData({ title = '', items = [] }) {
    console.log(arguments)
    const wrapper = this.element.querySelector('.theme-bar__wrapper')
    const buttonWrapper = this.element.querySelector('.theme-bar__buttons')

    if (!this.templateTitle || !this.templateButton || !wrapper || !buttonWrapper || (!title && !items.length)) {
      return
    }

    const cloneTitle = this.templateTitle.content.cloneNode(true)
    const elementTitle = cloneTitle.querySelector('.theme-bar__title')
    title ? (elementTitle.textContent = title) : elementTitle.remove()
    wrapper.appendChild(cloneTitle)

    items = items.filter(item => item.title && item.slug)
    items.forEach(({ title, slug }) => this.insertButton({ title, slug }, buttonWrapper))

    //items.forEach(({ objects }) => this.lazyLoadData(objects))
  }

  async lazyLoadData(objects = []) {
    objects = objects.filter(({ linkHref }) => linkHref?.indexOf('micr.io/') !== -1)
    const results = []

    for (const object of objects) {
      const urlParts = extractMicrioUrlParts(object.linkHref)

      if (urlParts.objectId) {
        const result = await fetch(dataUrlTEMP(urlParts.objectId)).then(response => response.ok && response.json())
        results.push(result)
      }
    }

    const result = results.filter(result => result?.markerTours?.length && result.markerTours[1])[0]
    const tour = result.markerTours[1]
    console.log('tour:', tour)
  }

  insertButton({ title = '', slug = '' }, buttonWrapper) {
    const cloneButton = this.templateButton.content.cloneNode(true)
    const elementButton = cloneButton.querySelector('.theme-bar__button')

    elementButton.textContent = title
    elementButton.href = `#${slug}`
    elementButton.addEventListener('click', event => this.onButtonClick(event, elementButton))

    buttonWrapper.appendChild(cloneButton)
  }

  async onButtonClick(event = {}, button) {
    if (!button || !button.href || !button.href[0] === '#') {
      return
    }

    event?.preventDefault()

    document.querySelectorAll('.landing-themes__theme--active').forEach(element => element.classList.remove('landing-themes__theme--active'))
    document.querySelectorAll('.theme-bar__button--active').forEach(element => element.classList.remove('theme-bar__button--active'))
    window.dispatchEvent(new CustomEvent('open-theme-overlay', { detail: button.href.split('#')[1] }))
  }
}

window.addEventListener('init-load', () => loadComponent(document, 'theme-bar', ThemeBarComponent))
